import {Flex, Text} from '@chakra-ui/react'
import {
  updateIsPauseAudio,
  updateTabScrollValue,
} from '@redux/exam-result/examResult'
import {useDispatch, useSelector} from 'react-redux'

const ScrollTab = ({audioRef}: any) => {
  const {dataExamResult, examResultPart, tabScrollValue, tabValue} =
    useSelector((state: any) => state.examResult)
  const dispatch = useDispatch()

  const handleClickScrollTab = (scrollTabValue: any) => {
    dispatch(updateTabScrollValue(scrollTabValue))
    if (scrollTabValue !== 'overview' && tabValue === 1) {
      const fistQuestionByTabValue =
        dataExamResult?.transcript_review?.transcripts.find(
          (item: any) => item.part_type === scrollTabValue,
        )
      audioRef.current.currentTime =
        fistQuestionByTabValue?.sentences[0].start_time
    } else {
      dispatch(updateIsPauseAudio(true))
    }
    const parent = document.querySelector(
      '.exam-result-scroll-tab',
    ) as HTMLElement
    const child = document.querySelector(`.${scrollTabValue}`) as HTMLElement
    if (parent && child) {
      if (scrollTabValue === 'overview') {
        parent.scrollTop = 0
      } else {
        parent.scrollTop = child.offsetTop - parent.offsetTop - 80
      }
    }
  }

  return (
    <Flex
      bg={'#F0F0F0'}
      gap={'4px'}
      p={'4px'}
      w={'fit-content'}
      borderRadius={'16px'}
      mx={'auto'}>
      {examResultPart.map((item: any, index: any) => {
        return (
          <Text
            key={index}
            fontSize={'16px'}
            fontWeight={600}
            p={'8px 20px'}
            borderRadius={'12px'}
            cursor={'pointer'}
            bg={tabScrollValue === item.type ? 'white' : 'unset'}
            boxShadow={
              tabScrollValue === item.type
                ? '0px 2px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 4px 0px rgba(0, 0, 0, 0.10)'
                : 'unset'
            }
            transition={'0.3s'}
            _hover={{
              bg: 'white',
            }}
            onClick={() => handleClickScrollTab(item.type)}>
            {item.display}
          </Text>
        )
      })}
    </Flex>
  )
}

export default ScrollTab
